import { ErrorHandler, Injectable } from '@angular/core';

const CHUNK_RELOAD_KEY = 'ltng_chunk_reload_once';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const chunkFailedMessage = /(Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk|Loading CSS chunk)/i;

    // Robustly extract message from nested error wrappers (Zone.js, Router, etc)
    let message = '';
    try {
      const parts = [];
      if (typeof error === 'string') parts.push(error);
      if (error?.message) parts.push(error.message);
      if (error?.rejection) {
        if (typeof error.rejection === 'string') parts.push(error.rejection);
        if (error.rejection?.message) parts.push(error.rejection.message);
      }
      if (error?.originalError) {
        if (typeof error.originalError === 'string') parts.push(error.originalError);
        if (error.originalError?.message) parts.push(error.originalError.message);
      }
      if (error?.error) {
        if (typeof error.error === 'string') parts.push(error.error);
        if (error.error?.message) parts.push(error.error.message);
      }
      if (error?.toString) parts.push(error.toString());
      message = parts.join(' | ');
    } catch {
      // Ignore stringify errors
    }

    if (message && chunkFailedMessage.test(message)) {
      // After a deploy, lazy chunks can 404. Reload once per session to recover.
      // Avoid loops during rapid navigation by never reloading more than once.
      try {
        if (typeof sessionStorage !== 'undefined' && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
          sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
          console.warn('[GlobalErrorHandler] Chunk load failed; reloading once to recover.', error);
          window.location.reload();
          return;
        }
      } catch {
        // sessionStorage unavailable — fall through to suppress only
      }
      console.warn('[GlobalErrorHandler] Chunk load failed (already reloaded once this session).', error);
      return;
    }

    // For all other errors, delegate to default browser console logging
    console.error(error);
  }
}
